export const NOMBRES_CAPITULOS: Record<string, string> = {
  "10": "Cereales",
  "11": "Productos de la molinería; malta; almidón y fécula; inulina; gluten de trigo",
  "12": "Semillas y frutos oleaginosos; semillas y frutos diversos; plantas industriales o medicinales; paja y forraje",
  "13": "Gomas, resinas y demás jugos y extractos vegetales",
  "14": "Materias trenzables y demás productos de origen vegetal, no expresados ni comprendidos en otra parte",
  "15": "Grasas y aceites animales o vegetales; productos de su desdoblamiento; grasas alimenticias elaboradas; ceras de origen animal o vegetal",
  "16": "Preparaciones de carne, pescado o de crustáceos, moluscos o demás invertebrados acuáticos",
  "17": "Azúcares y artículos de confitería",
  "18": "Cacao y sus preparaciones",
  "19": "Preparaciones a base de cereales, harina, almidón, fécula o leche; productos de pastelería",
  "20": "Preparaciones de hortalizas, frutas u otros frutos o demás partes de plantas",
  "21": "Preparaciones alimenticias diversas",
  "22": "Bebidas, líquidos alcohólicos y vinagre",
  "23": "Residuos y desperdicios de las industrias alimentarias; alimentos preparados para animales",
  "24": "Tabaco y sucedáneos del tabaco elaborados",
  "25": "Sal; azufre; tierras y piedras; yesos, cales y cementos",
  "26": "Minerales metalíferos, escorias y cenizas",
  "27": "Combustibles minerales, aceites minerales y productos de su destilación; materias bituminosas; ceras minerales",
  "28": "Productos químicos inorgánicos; compuestos inorgánicos u orgánicos de metales preciosos, de elementos radiactivos, de metales de las tierras raras o de isótopos",
  "29": "Productos químicos orgánicos",
  "30": "Productos farmacéuticos",
  "31": "Abonos",
  "32": "Extractos curtientes o tintóreos; taninos y sus derivados; pigmentos y demás materias colorantes; pinturas y barnices; mástiques; tintas",
  "33": "Aceites esenciales y resinoides; preparaciones de perfumería, de tocador o de cosmética",
  "34": "Jabón, agentes de superficie orgánicos, preparaciones para lavar, preparaciones lubricantes, ceras artificiales, ceras preparadas, productos de limpieza, velas y artículos similares, pastas para modelar, 'ceras para odontología' y preparaciones para odontología a base de yeso fraguable",
  "35": "Materias albuminoideas; productos a base de almidón o de fécula modificados; colas; enzimas",
  "36": "Pólvora y explosivos; artículos de pirotecnia; fósforos; aleaciones pirofóricas; materias inflamables",
  "37": "Productos fotográficos o cinematográficos",
  "38": "Productos químicos diversos",
  "39": "Plásticos y sus manufacturas",
  "40": "Caucho y sus manufacturas",
  "41": "Pieles (excepto la peletería) y cueros",
  "42": "Manufacturas de cuero; artículos de guarnicionería o de talabartería; artículos de viaje, bolsos de mano (carteras) y continentes similares; manufacturas de tripa",
  "43": "Peletería y confecciones de peletería; peletería facticia o artificial",
  "44": "Madera, carbón vegetal y manufacturas de madera",
  "45": "Corcho y sus manufacturas",
  "46": "Manufacturas de espartería o cestería",
  "47": "Pasta de madera o de las demás materias fibrosas celulósicas; papel o cartón para reciclar (desperdicios y desechos)",
  "48": "Papel y cartón; manufacturas de pasta de celulosa, de papel o cartón",
  "49": "Productos editoriales, de la prensa y de las demás industrias gráficas; textos manuscritos o mecanografiados y planos",
  "50": "Seda",
  "51": "Lana y pelo fino u ordinario; hilados y tejidos de crin",
  "52": "Algodón",
  "53": "Las demás fibras textiles vegetales; hilados de papel y tejidos de hilados de papel",
  "54": "Filamentos sintéticos o artificiales; láminas y formas similares de materia textil sintética o artificial",
  "55": "Fibras sintéticas o artificiales discontinuas",
  "56": "Guata, fieltro y tela sin tejer; hilados especiales; cordeles, cuerdas y cordajes; artículos de cordelería",
  "57": "Alfombras y demás revestimientos para el suelo, de materia textil",
  "58": "Tejidos especiales; superficies textiles con mechón insertado; encajes; tapicería; pasamanería; bordados",
  "59": "Tejidos impregnados, recubiertos, revestidos o estratificados; artículos técnicos de materia textil",
  "60": "Prendas y complementos (accesorios), de vestir, de punto",
  "61": "Prendas y complementos (accesorios), de vestir, excepto los de punto",
  "62": "Los demás artículos textiles confeccionados; juegos; prendería y trapos",
  "63": "Calzado, polainas y artículos análogos; partes de estos artículos",
  "64": "Sombreros, demás tocados, y sus partes",
  "65": "Paraguas, sombrillas, quitasoles, bastones, bastones asiento, látigos, fustas, y sus partes",
  "66": "Plumas y plumón preparados y artículos de plumas o plumón; flores artificiales; manufacturas de cabello",
  "67": "Manufacturas de piedra, yeso fraguable, cemento, amianto (asbesto), mica o materias análogas",
  "68": "Productos cerámicos",
  "69": "Vidrio y sus manufacturas",
  "70": "Perlas finas (naturales) o cultivadas, piedras preciosas o semipreciosas, metales preciosos, chapados de metal precioso (plaqué) y manufacturas de estas materias; bisutería; monedas",
  "71": "Fundición, hierro y acero",
  "72": "Manufacturas de fundición, hierro o acero",
  "73": "Cobre y sus manufacturas",
  "74": "Níquel y sus manufacturas",
  "75": "Aluminio y sus manufacturas",
  "76": "Plomo y sus manufacturas",
  "78": "Cinc y sus manufacturas",
  "79": "Estaño y sus manufacturas",
  "80": "Los demás metales comunes; cermets; manufacturas de estas materias",
  "81": "Herramientas y útiles, artículos de cuchillería y cubiertos de mesa, de metal común; partes de estos artículos, de metal común",
  "82": "Manufacturas diversas de metal común",
  "83": "Reactores nucleares, calderas, máquinas, aparatos y artefactos mecánicos; partes de estas máquinas o aparatos",
  "84": "Máquinas, aparatos y material eléctrico, y sus partes; aparatos de grabación o reproducción de sonido, aparatos de grabación o reproducción de imagen y sonido en televisión, y las partes y accesorios de estos aparatos",
  "85": "Vehículos y material para vías férreas o similares, y sus partes; aparatos mecánicos (incluso electromecánicos) de señalización para vías de comunicación",
  "86": "Vehículos automóviles, tractores, velocípedos y demás vehículos terrestres, sus partes y accesorios",
  "87": "Aeronaves, vehículos espaciales, y sus partes",
  "88": "Barcos y demás artefactos flotantes",
  "89": "Instrumentos y aparatos de óptica, fotografía o cinematografía, de medida, control o precisión; instrumentos y aparatos medicoquirúrgicos; partes y accesorios de estos instrumentos o aparatos",
  "90": "Relojería",
  "91": "Instrumentos musicales, sus partes y accesorios",
  "92": "Armas, municiones, y sus partes y accesorios",
  "93": "Muebles; mobiliario medicoquirúrgico; artículos de cama y similares; aparatos de alumbrado no expresados ni comprendidos en otra parte; anuncios, letreros y placas indicadoras luminosos y artículos similares; construcciones prefabricadas",
  "94": "Juguetes, juegos y artículos para recreo o deporte; sus partes y accesorios",
  "95": "Manufacturas diversas",
  "96": "Objetos de arte o colección y antigüedades",
  "97": "Operaciones Especiales",
  "98": "Operaciones Especiales",
  "01": "Animales vivos",
  "02": "Carne y despojos comestibles",
  "03": "Pescados y crustáceos, moluscos y demás invertebrados acuáticos",
  "04": "Leche y productos lácteos; huevos de ave; miel natural; productos comestibles de origen animal, no expresados ni comprendidos en otra parte",
  "05": "Los demás productos de origen animal no expresados ni comprendidos en otra parte",
  "06": "Plantas vivas y productos de la floricultura",
  "07": "Hortalizas, plantas, raíces y tubérculos alimenticios",
  "08": "Frutas y frutos comestibles; cortezas de agrios (ágrumes), melones o sandías",
  "09": "Café, té, yerba mate y especias"
};
